import React from "react";
import { useParams } from "react-router-dom";
import CaseListPage from "./CaseListPage";
import { newCasesConfig } from "./caseListConfig";

const IndexUserNewCases = () => {
  const { type } = useParams();
  return <CaseListPage config={ { ...newCasesConfig, type: type || newCasesConfig.type } } />;
};

export default IndexUserNewCases;
